import axiosInstance from '../../helpers/interceptor';
import { getItem } from '../../utils/localStorage';
import {
  ISelfAssessmentDepartment,
  ISelfAssessmentPayload,
} from '../@types/selfAssessment';

export const getDepartments = async () => {
  const brandId = JSON.parse(getItem('selectedBrand'));
  const hotelId = JSON.parse(getItem('selectedHotel'));
  return await axiosInstance
    .get<ISelfAssessmentDepartment>(
      `${Env.API_URL}/template/departments/${brandId}/${hotelId}`
    )
    .then((response) => response.data);
};

export const createSelfAssessmentv2 = async (
  payLoad: ISelfAssessmentPayload[]
) => {
  const { data } = await axiosInstance.post(
    `${Env.API_URL}/selfAssessment`,
    payLoad
  );
  return data;
};
